import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import TextInput from "../../../Common/FormElements/TextInput/TextInput";
import CalendarInput from "../../../Common/FormElements/CalendarInput/CalendarInput";
import Button from "../../../Common/FormElements/Button/Button";
import { closeRightModal } from "../../../../REDUX/actions/rightModal";
import UploadButton from "../../../Common/FormElements/UploadButton/UploadButton";
import { createEvent } from "../../../../REDUX/actions/events";
import TextArea from "../../../Common/FormElements/TextArea/TextArea";
import { getOrganizations } from "../../../../REDUX/actions/organziation";
import CustomMultiSelect from "../../../Common/FormElements/MultiSelect";
import { useTranslation } from "react-i18next";
import Select from "../../../Common/FormElements/Select/Select";
import SwitchButton from "../../../Common/FormElements/SwitchButton/SwitchButton";

const NewEvent = () => {
  const { t } = useTranslation("common");

  const selectOptions = [
    { name: t("Expo and Fair"), code: "expo_fair" },
    {
      name: t("Delivery Trade Fair & Exhibition"),
      code: "delivery_trade_fair_exhibition",
    },
    { name: t("Open House"), code: "open_house" },
    { name: t("Google Ads"), code: "google_ads" },
    { name: t("Meta Ads"), code: "meta_ads" },
    { name: t("Flyer Campaign"), code: "flyer_campaign" },
    { name: t("Radio Campaign"), code: "radio_campaign" },
    { name: t("City Poster"), code: "city_poster" },
  ];

  /* ***************************** consts && hooks **************************** */
  const dispatch = useDispatch();
  const { organizations } = useSelector((state) => state.organizationReducer);
  const { user } = useSelector((state) => state.userReducer);
  const [organizationOptions, setOrganizationOptions] = useState([]);
  const [eventBoolean, setEventBoolean] = useState(false);
  const [eventFormData, setEventFormData] = useState({
    isGlobal: false,
  });
  const modalTitle = t("Event");
  const { createdEventLoading } = useSelector((state) => state.eventsReducer);

  const userRole = user?.attributes?.userRole;

  /* ******************************** callBacks ******************************* */
  // handle change normal inputs :
  const handleChange = (field, value) => {
    setEventFormData((prevFormData) => ({
      ...prevFormData,
      [field]: value,
    }));
  };
  // handle change => calendar / time :
  const handleCalendarInput = (e, name) => {
    const { value } = e;
    let formattedValue = value;
    if (name === "startTime" || name === "endTime") {
      const momentValue = moment(value, "HH:mm:ss.SSS");
      if (momentValue.isValid()) {
        formattedValue = momentValue.format("HH:mm:ss.SSS");
      }
    }
    setEventFormData((prevFormData) => ({
      ...prevFormData,
      [name]: formattedValue,
    }));
  };
  // handle the image change
  const handleImageChange = (e) => {
    const imageFile = e.target.files[0];
    if (imageFile) {
      setEventFormData((prevFormData) => ({
        ...prevFormData,
        photo: imageFile,
      }));
    }
  };

  const handleDocumentChange = (e) => {
    const documentFile = e.target.files[0];
    if (documentFile) {
      setEventFormData((prevFormData) => ({
        ...prevFormData,
        document: documentFile,
      }));
    }
  };

  // handle submit event form
  const handleSubmit = () => {
    dispatch(
      createEvent(
        {
          newEvent: {
            ...eventFormData,
            startDate: moment(eventFormData.startDate)?.utc(true).toDate(),
            endDate: moment(eventFormData.endDate)?.utc(true).toDate(),
          },
        },
        t
      )
    );
  };

  useEffect(() => {
    if (userRole === 0) {
      setEventFormData({
        resellers: [
          user?.attributes?.profil?.data?.attributes?.reseller?.data?.id,
        ],
      });
      return;
    }
    let filters = {};

    if (userRole === 2) {
      filters = {
        business_affiliate: {
          user: {
            id: {
              $eq: user.id,
            },
          },
        },
      };
    }

    dispatch(getOrganizations(filters));
  }, [dispatch, user, userRole]);

  useEffect(() => {
    setOrganizationOptions(
      organizations?.map((item) => ({ label: item?.name, value: item?.code }))
    );
  }, [organizations]);

  const formDataIncomplete =
    !eventFormData.title ||
    !eventFormData.startDate ||
    !eventFormData.endDate ||
    !eventFormData.startTime ||
    !eventFormData.endTime ||
    !eventFormData.eventType ||
    ([1, 2].includes(userRole) &&
      !eventFormData.isGlobal &&
      !eventFormData.resellers?.length > 0);

  /* ******************************** Rendering ******************************* */
  return (
    <div className="evenementModal px-5 d-flex flex-column justify-content-between h100 ">
      <div>
        <h1 className="quickSand f25 sBold text-blue mb-4">
          {t(modalTitle === "Event" ? "Add an" : "Add a")} {modalTitle}
        </h1>
        <div className="row g-4">
          {userRole === 1 && (
            <div className="d-flex col-12 gap-2">
              <span className="text-softBlack normal f14">{t("Reseller")}</span>
              <SwitchButton
                small
                isActive={eventFormData.isGlobal}
                onClick={() => {
                  if (!!!eventFormData.isGlobal) {
                    handleChange("resellers", []);
                  }
                  handleChange("isGlobal", !!!eventFormData.isGlobal);
                }}
              />
              <span className="text-softBlack normal f14">{t("Poseidon")}</span>
            </div>
          )}
          {userRole !== 0 && !eventFormData.isGlobal && (
            <div className="d-flex flex-column col-12 gap-2">
              <span className="text-softBlack normal f16">
                {t("Reseller")}
                <span className="ms-1 text-whyBotherGrey f12">
                  ({t("Required")})
                </span>
              </span>{" "}
              <CustomMultiSelect
                filter
                name="resellers"
                placeholder=""
                value={eventFormData?.resellers}
                options={organizationOptions}
                callback={(e) => handleChange("resellers", e.target.value)}
              />
            </div>
          )}
          <div className="d-flex flex-column gap-2 col-12">
            <span className="text-softBlack normal f16">
              {t("Title")}
              <span className="ms-1 text-whyBotherGrey f12">
                ({t("Required")})
              </span>
            </span>
            <TextInput
              className="w100"
              value={eventFormData?.title || ""}
              callback={(e) => handleChange("title", e.target.value)}
            />
          </div>
          <div className="col-6 d-flex flex-column gap-2">
            <span className="text-softBlack normal f16">
              {t("Event start date")}

              <span className="ms-1 text-whyBotherGrey f12">
                ({t("Required")})
              </span>
            </span>
            <CalendarInput
              className="w100"
              callback={(event) => handleCalendarInput(event, "startDate")}
            />
          </div>
          <div className="col-6 d-flex flex-column gap-2">
            <span className="text-softBlack normal f16">
              {t("Event end date")}
              <span className="ms-1 text-whyBotherGrey f12">
                ({t("Required")})
              </span>
            </span>
            <CalendarInput
              className="w100"
              callback={(event) => handleCalendarInput(event, "endDate")}
            />
          </div>

          <div className="col-6 d-flex flex-column gap-2">
            <span className="text-softBlack normal f16">
              {t("Start time")}

              <span className="ms-1 text-whyBotherGrey f12">
                ({t("Required")})
              </span>
            </span>
            <CalendarInput
              className="w100"
              callback={(event) => handleCalendarInput(event, "startTime")}
              timeOnly
              minDate={false}
            />
          </div>
          <div className="col-6 d-flex flex-column gap-2">
            <span className="text-softBlack normal f16">
              {t("End time")}

              <span className="ms-1 text-whyBotherGrey f12">
                ({t("Required")})
              </span>
            </span>
            <CalendarInput
              className="w100"
              callback={(event) => handleCalendarInput(event, "endTime")}
              timeOnly
              minDate={false}
            />
          </div>

          <div className="col-6 d-flex flex-column gap-2">
            <span className="text-softBlack normal f16">
              {t("Event type")}
              <span className="ms-1 text-whyBotherGrey f12">
                ({t("Required")})
              </span>
            </span>
            <div className="alignH">
              <Select
                options={selectOptions}
                value={eventFormData?.eventType}
                callback={(e) => handleChange("eventType", e.target.value)}
              />
            </div>
          </div>
          {!eventFormData.isGlobal && (
            <>
              <div className="d-flex flex-column gap-2 col-6">
                <span className="text-softBlack normal f16">{t("Budget")}</span>
                <TextInput
                  type="number"
                  className="w100"
                  value={eventFormData?.budget || ""}
                  euro
                  callback={(e) => handleChange("budget", e.target.value)}
                />
              </div>

              <div className="d-flex flex-column gap-2 col-6">
                <span className="text-softBlack normal f16">
                  {t("Number of spas sold")}
                </span>
                <TextInput
                  type="number"
                  className="w100"
                  value={eventFormData?.spa_sold}
                  callback={(e) => handleChange("spa_sold", e.target.value)}
                />
              </div>
              <div className="d-flex flex-column gap-2 col-6">
                <span className="text-softBlack normal f16">
                  {t("Number of swim spas sold")}
                </span>
                <TextInput
                  type="number"
                  className="w100"
                  value={eventFormData?.swim_spa_sold}
                  callback={(e) =>
                    handleChange("swim_spa_sold", e.target.value)
                  }
                />
              </div>

              <div className="d-flex flex-column gap-2 col-6">
                <span className="text-softBlack normal f16">
                  {t("Number of quotes")}
                </span>
                <TextInput
                  type="number"
                  className="w100"
                  value={eventFormData?.quotes_count}
                  callback={(e) => handleChange("quotes_count", e.target.value)}
                />
              </div>
            </>
          )}

          <div className="col-6 d-flex flex-column gap-2">
            <span className="text-softBlack normal f16">
              {t("Link to view")}
            </span>
            <TextInput
              className="w100"
              value={eventFormData?.visitLink}
              callback={(e) => handleChange("visitLink", e.target.value)}
            />
          </div>
          <div
            className={`col-6 d-${
              eventBoolean ? "none" : "flex"
            } justify-content-start flex-column`}
          >
            <span className="text-softBlack normal f16">
              {t("Cover image")}
            </span>
            <UploadButton
              name="cover"
              type={"file"}
              text={`${
                eventFormData?.photo?.name || t("Add attachments (max. 15 MB)")
              }`}
              callback={handleImageChange}
              className="coverImg flex-grow-1"
            />
          </div>
          <div className="col-6">
            <span className="text-softBlack normal f16">
              {t("Description")}
            </span>
            <TextArea
              className="w100 mt-2"
              value={eventFormData?.description || ""}
              callback={(e) => handleChange("description", e.target.value)}
            />
          </div>

          {eventFormData.isGlobal && (
            <div
              className={`col-6 d-flex gap-2 justify-content-start flex-column`}
            >
              <span className="text-softBlack normal f16">
                {t("PDF Document")}
              </span>
              <UploadButton
                name="document"
                type={"file"}
                text={`${
                  eventFormData?.document?.name ||
                  t("Add a document (max. 15 MB)")
                }`}
                callback={handleDocumentChange}
                className="coverImg flex-grow-1"
              />
            </div>
          )}
        </div>
      </div>
      {/* Buttons */}
      <div className="align-self-center alignH gap-3 mt-5">
        <Button
          variant={"outline"}
          className="px-5"
          onClick={() => dispatch(closeRightModal())}
        >
          {t("Cancel")}
        </Button>
        <Button
          className="px-5"
          onClick={handleSubmit}
          formDataIncomplete={formDataIncomplete}
          loading={createdEventLoading}
        >
          {t("Save")}
        </Button>
      </div>
    </div>
  );
};

export default NewEvent;
